
/*eslint-disable*/
import Picker from 'vux/src/components/picker/index.vue'
import Group from 'vux/src/components/group/index.vue'
import PopupPicker from 'vux/src/components/popup-picker/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import XDialog from 'vux/src/components/x-dialog/index.vue'
import Confirm from 'vux/src/components/confirm/index.vue'

import { mapState } from "vuex";
import { commonApi, check } from "@/common/index";
import { setTimeout } from "timers";
import {
discountUserInfoOptions,
resetTextBylangKey,
} from "../../../libs/options.js";
import { ValidateRequire, validataNumber } from "@/common/utils/validate.js";
export default {
name: "discountsDetail",
directives: {
TransferDom,
},
components: {
XButton,
XDialog,
Flexbox,
FlexboxItem,
Group,
XInput,
PopupPicker,
Picker,
Confirm,
},
data() {
return {
/*
"accountType": "账户类型 0 - 主账户； 1 - 游戏账户；",
*bonusType红利类型：
* BETFLOW("1", "流水优惠"),DEPOSIT("2", "存款优惠"),INVITE("3", "邀请优惠"),
* CHECK_IN("4", "签到优惠"),OTHER("5", "人工审核优惠"),ConDeposit("6", "连续充值"),
* REGISTER("7","注册优惠"),DEPOSIT_CHANNELS("8","存款渠道优惠"),BETORDER("9","注单优惠"),
* BET("10", "投注优惠"),REAL_TIME_BET_FLOW("11", "实时返水优惠"),DEPOSIT_REAL("12","实时存款优惠"),
* BIND_USERINFO("13","信息绑定优惠"), PRIZE("14","派彩优惠"),CHECK_IN_INTEGRAL("15","签到积分优惠"),
* DEPOSIT_BETFLOW("16","连续存投优惠"),BETFLOW_UPGRADE("17","投注升级优惠"),DAILY_TASK("19","日常任务奖励优惠"),
* SIGN_IN("21","新签到优惠"),BALANCE_RATE("22","余额宝优惠"),VIP_DEPOSIT("23", "VIP存款优惠");
* 需要领取的优惠类型 2存款红利 9注单优惠 11返水优惠 7注册优惠 17升级查询 24客户定制优惠
*/
details: null,
showBtn: ["2", "9", "11"], // 需要领取的优惠
showDiffBtn: ["7", "24", "25"], // applyType 必须等于2手动领取 才显示

showUserUpgradinfo: false,
isShowToast: false, // 弹窗 领取红利
isShowDialog: false, // 弹窗 展示平台列表
currentPlatform: {

code: [],
name: "",
},
applyAmount: "", // 红利申请金额
isReady: true, // 阻止重复点击
betOrderNo: "", //注单编号
};
},
computed: {
...mapState({
UUID: (state) => state.UUID,
isLogin: (state) => state.isLogin,
userInfo: (state) => state.userInfo.userInfo,
customer_service_system_link: (state) =>
state.FrontConfigList.customer_service_system_link,
allBonusArticle: (state) => state.allBonusArticle,
isApp: (state) => state.isApp, //是否在app打开
}),
discountUserInfo() {
return resetTextBylangKey(
discountUserInfoOptions,
this.$t("discounts").userInformation
);
},
},
activated() {




this.details = Object.assign({}, this.$route.query);
this._getDetails();
},
methods: {
_getDetails() {

commonApi.DISCOUNTS.queryBonusArticleInfoDetail({
infoId: this.details.id,
appType: 1,
})
.then((data) => {
if (data) {
this.details = Object.assign({}, data, this.details);
this.details.articleInfo = data.articleInfo
.replace(/<table/g, '<div class="table-wrap"><table')
.replace(/<\/table>/g, "</table></div>");
if (data.platformList) {

data.platformList.forEach((item, index) => {
const { fullName, platformKey } = item;
item["name"] = fullName;
item["value"] = platformKey;
if (index === 0)
this.currentPlatform = {
name: fullName,
code: [platformKey],
};
});
this.details.platformList = [data.platformList];
}
}
})
.catch((err) => {});
},

_getUserUpgradeInfo() {

if (!this.checkisLogin()) return;
commonApi.DEPOSIT.selectUserUpgradeInfo({
UUID: this.UUID,
configId: this.details.configId,
})
.then((res) => {
if (!res.data.data) {
this.$vux.toast.show({ text: res.data.msg, type: "cancel" });
return;
}
const result = res.data.data;
this.discountUserInfo.forEach((item) => {
if (result[item.langKey]) item.val = result[item.langKey];
});
this.showUserUpgradinfo = true;
})
.catch((err) => {
this.$vux.toast.show({ text: err, type: "cancel" });
});
},

handlePlatformChange(val) {

const current = this.details.platformList[0].filter(
(item) => item.platformKey === val[0]
);
this.currentPlatform.name = current[0]["fullName"];
},

handleDiscount() {

if (!this.isReady || !this.checkisLogin()) return;
const { applyType, accountType, bonusType } = this.details;

if (
bonusType === "11" ||
bonusType === "24" ||
bonusType === "25" ||
(bonusType === "7" && applyType === "2")
) {
this._getBonus();
return;
}
if (accountType === "0") this._getApplyBonus();
if (accountType !== "0") this.isShowToast = true;
},

_getApplyBonus() {

this.isReady = false;
const params = {
configId: this.details.configId,
platformKey: this.currentPlatform.code[0],
};
const { bonusType, accountType } = this.details;
if (accountType !== "0") {
if (bonusType === "9") {
if (!ValidateRequire(this.betOrderNo)) {
this.$vux.toast.show({
text: this.$t("discounts").betOrderNo,
type: "cancel",
});
return;
}
params.betOrderNo = this.betOrderNo; 
} else {
if (!validataNumber(this.applyAmount)) {
this.$vux.toast.show({
text: this.$t("mine").Withdrawal.Draw.check.amount1,
type: "cancel",
});
return;
}
params.applyAmount = this.applyAmount; 
}
}
this.$api.post(
this.$urls.DEPOSIT.applyBonus,
params,
(resp) => {
if (resp.data.code === 200) {
this.$vux.toast.show({ text: resp.data.msg, type: "success" });
} else if (resp.data.code === 808) {
this.$vux.toast.show({ text: resp.data.msg, type: "cancel" });
let timer = setTimeout(() => {
this.$router.push({ path: "/funds/deposite" });
clearTimeout(timer);
}, 2000);
} else {
let msg = resp.data.msg ? resp.data.msg : resp.data.message;
this.$vux.toast.show({ text: msg, type: "cancel" });
}
this.isReady = true;
this.isShowToast = false;
},
(err) => {
this.isReady = true;
this.isShowToast = false;
}
);
},

checkisLogin() {

let pass = true;
if (!this.isLogin) {
pass = false;
this.$vux.toast.show({
text: this.$t("discounts").needLoin,
type: "cancel",
});
let timer = setTimeout(() => {
this.$store.commit("SET_LOGIN_SHOW");
clearTimeout(timer);
}, 1000);
}
return pass;
},

_getBonus() {
this.isReady = false;
const params = { UUID: this.UUID };
let request = null;
if (this.details.bonusType === "11") {

request = this.$urls.DEPOSIT.getRealTimeAmount;
params.configId = this.details.configId;
}
if (this.details.bonusType === "7")
request = this.$urls.DEPOSIT.getUserAgentBonus;
if (this.details.bonusType === "24") {

request = this.$urls.DEPOSIT.applyPrivateBonus;
params.bonusId = this.details.configId;
}
if (this.details.bonusType === "25") {

request = this.$urls.DEPOSIT.applyBonus;
params.configId = this.details.configId;
}
if (!request) return;
this.$api.post(
request,
params,
(resp) => {
const { code, data, msg, message } = resp.data;
if (code === 200) {
const text = data || msg;
this.$vux.toast.show({ text, type: "success" });
} else {
const text = msg || message;
this.$vux.toast.show({ text, type: "cancel" });
}
this.isShowToast = false;
this.isReady = true;
},
(err) => {
this.isReady = true;
}
);
},
},
};



// WEBPACK FOOTER //
// ./src/pages/build800/views/discounts/discountsDetail/index.vue